import React from 'react';
import { useHospitalOnboarding } from '../../contexts/HospitalOnboardingContext';
import { Check } from 'lucide-react';

const HOSPITAL_STEPS = [
  { id: 1, label: 'Hospital profile' },
  { id: 2, label: 'Facilities & contacts' },
  { id: 3, label: 'Ambulance requirements' },
  { id: 4, label: 'Areas & destinations' },
  { id: 5, label: 'Review & submit' }
];

export const OnboardingStepProgressBar = () => {
  const { currentStep, setCurrentStep } = useHospitalOnboarding();

  return (
    <div className="w-full mb-8">
      {/* 5 Step Horizontal Tab Cards matching layout with BLUE theme */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3">
        {HOSPITAL_STEPS.map((step) => {
          const isActive = step.id === currentStep;
          const isCompleted = step.id < currentStep;

          return (
            <button
              key={step.id}
              type="button"
              onClick={() => {
                if (step.id <= currentStep) {
                  setCurrentStep(step.id);
                }
              }}
              disabled={step.id > currentStep}
              className={`w-full flex items-center justify-center gap-2 py-2.5 sm:py-3 px-3 rounded-lg border text-xs sm:text-sm transition-all duration-150 select-none ${
                isActive
                  ? 'bg-blue-50 border-2 border-blue-600 text-blue-700 shadow-2xs font-semibold'
                  : isCompleted
                  ? 'bg-white border border-slate-200 text-slate-700 hover:border-slate-300 cursor-pointer font-medium'
                  : 'bg-white border border-slate-200/80 text-slate-400 cursor-not-allowed font-normal'
              }`}
            >
              {/* Step circle number */}
              <span
                className={`w-5 h-5 rounded-full flex items-center justify-center text-[11px] shrink-0 ${
                  isActive
                    ? 'bg-blue-600 text-white font-bold'
                    : isCompleted
                    ? 'bg-blue-50 border border-blue-300 text-blue-600 font-bold'
                    : 'border border-slate-300 text-slate-400 font-normal'
                }`}
              >
                {isCompleted ? <Check className="w-3 h-3 stroke-[2.5]" /> : step.id}
              </span>

              {/* Step title label */}
              <span className="truncate">{step.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OnboardingStepProgressBar;
